import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { IconType } from 'components/DesignSystem/Icon/icons';
import { ListedMassMail } from 'helper/mailer';
import { cssVar } from 'constants/theme';

import './index.scss';

// Mesma semântica de status do desktop (checkmark verde = finalizado), estendida
// no card para também mostrar "Enviado", já que o dado (isSent) está disponível.
const STATUS_STEPS: { key: 'isSent' | 'isFinished', icon: IconType, label: string }[] = [
  { key: 'isSent', icon: 'message', label: 'Enviado' },
  { key: 'isFinished', icon: 'checkmark', label: 'Finalizado' },
];

const ACTIVE_COLOR = cssVar('success-solid');
const INACTIVE_COLOR = cssVar('text-disabled');

export default function MassEmailCard({ massEmail }: {
  massEmail: ListedMassMail,
}) {
  const {
    subject, identifierCode, sendDate,
  } = massEmail;

  return (
    <div className="mass-email-card">
      <h3 className="mass-email-card-title">{subject}</h3>
      <p className="mass-email-card-id">{identifierCode}</p>
      <dl className="mass-email-card-meta">
        <div>
          <dt>Data</dt>
          <dd>{sendDate}</dd>
        </div>
      </dl>
      <div className="mass-email-card-status">
        {STATUS_STEPS.map((step) => {
          const active = Boolean(massEmail[step.key]);
          return (
            <span
              key={step.key}
              className="mass-email-card-status-item"
              aria-label={`${step.label}: ${active ? 'concluído' : 'pendente'}`}
            >
              <Icon
                id={`${step.key}-${identifierCode}`}
                iconType={step.icon}
                color={active ? ACTIVE_COLOR : INACTIVE_COLOR}
                size="large"
              />
            </span>
          );
        })}
      </div>
    </div>
  );
}
